import React, { useEffect, useState } from "react";
import { useParams,useHistory  } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import useEstadoSalvamento from "../Utils/useEstadoSalvamento";
import { getAuth } from "firebase/auth";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItemButton,
  ListItemText,
  CircularProgress,
  Card,
  Divider,
  MenuItem,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";

import {
  collection,
  addDoc,
  getDocs,
  getDoc,
  setDoc,
  doc,
  query,
  where,
  serverTimestamp,
  orderBy
} from "firebase/firestore";

import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL
} from "firebase/storage";

import { db } from "../Config/firebase";
import { consultaTenantAtual , aplicarTenantAtual} from "../Utils/tenant";

const documentosBase = {
  funcionario: [
    { nome: "CPF", obrigatorio: true },
    { nome: "Carteira de Trabalho (CTPS)", obrigatorio: true },
    { nome: "Comprovante de Residência", obrigatorio: true },
  
  ],
  prestador: [
    { nome: "Contrato de prestação de serviço", obrigatorio: true },
    { nome: "CNPJ", obrigatorio: true },
    { nome: "CCMEI", obrigatorio: true },
    { nome: "Nota fiscal", obrigatorio: true }
  ]
};

const documentosTecnicos = {
  engenheiro: [
    { nome: "CREA", obrigatorio: true },
    { nome: "ART", obrigatorio: true }
  ],
  tecnico: [
    { nome: "Registro profissional", obrigatorio: true },
    { nome: "NR-10", obrigatorio: false, temVencimento: true, periodicidadeMeses: 12 }
  ]
};

const storage = getStorage();
async function abrirVersaoDocumento(storagePath) {
  try {
    const url = await getDownloadURL(ref(storage, storagePath));
    window.open(url, "_blank");
  } catch (err) {
    alert("Não foi possível abrir o documento.");
  }
}

const auth = getAuth();

function calcularDataVencimento(dataISO, meses) {
  if (!dataISO || !meses) return null;

  const data = new Date(dataISO);
  data.setMonth(data.getMonth() + meses);
  return data;
}


export default function CadastroFuncionario() {
  const { salvandoCadastro, executarSalvamento } = useEstadoSalvamento();
  const { funcionarioId } = useParams();
  const history = useHistory(); // ✅ AQUI DENTRO

  const [filtroStatus, setFiltroStatus] = useState("ativos"); 
// ativos = default (sem N/A)
  const [funcionario, setFuncionario] = useState(null);
  const [docs, setDocs] = useState([]);

  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [pendentes, setPendentes] = useState([]);

  const [dialogDoc, setDialogDoc] = useState(false);
  const [dialogNovoTipo, setDialogNovoTipo] = useState(false);

  const [motivoSubstituicao, setMotivoSubstituicao] = useState("");


  const [arquivo, setArquivo] = useState(null);
  const [tipoSelecionado, setTipoSelecionado] = useState("");

  const [novoNome, setNovoNome] = useState("");
  const [novoObrigatorio, setNovoObrigatorio] = useState(false);
  const [novoTemVencimento, setNovoTemVencimento] = useState(false);
  const [novoPeriodicidade, setNovoPeriodicidade] = useState("");
  const [novoDescricaoVencimento, setNovoDescricaoVencimento] = useState("");
  const [dataReferencia, setDataReferencia] = useState("");

  const [dialogUpload, setDialogUpload] = useState(false);
  const [tipoUpload, setTipoUpload] = useState(null);
  const [docExistente, setDocExistente] = useState(null);





  const [salvando, setSalvando] = useState(false);
  const [reload, setReload] = useState(0);
  const [uploadingCodigo, setUploadingCodigo] = useState(null);

  /* =========================
   HISTÓRICO – POPUP
========================= */
const [dialogHistorico, setDialogHistorico] = useState(false);
const [historicoSelecionado, setHistoricoSelecionado] = useState([]);

  /* =========================
     FUNCIONÁRIO
  ========================= */
  useEffect(() => {
  async function carregarFuncionario() {
    const snap = await getDoc(doc(db, "dp_funcionarios", funcionarioId));
    const data = { id: snap.id, ...snap.data() };

    setFuncionario(data);
    setReload(r => r + 1); // 🔥 IMPORTANTE
  }

  carregarFuncionario();
}, [funcionarioId]);



  /* =========================
     marcarComoNA
  ========================= */

 async function marcarComoNA(tipo) {
  const existente = docs.find(d =>
    d.tipoDocumentoNome?.trim().toLowerCase() === tipo.nome.trim().toLowerCase()
  );

  if (existente) {
    await setDoc(
      doc(db, "dp_documentos", existente.id),
      { na: true },
      { merge: true }
    );
  } else {
    await setDoc(
      doc(collection(db, "dp_documentos")),
      aplicarTenantAtual({
        funcionarioId,
        tipoDocumentoCodigo: tipo.codigo,
        tipoDocumentoNome: tipo.nome,
        na: true,
        createdAt: serverTimestamp()
      })
    );
  }

  setReload(r => r + 1);
}
  /* =========================
     TIPOS DE DOCUMENTO
  ========================= */
  useEffect(() => {
    async function carregarTipos() {
      const snap = await getDocs(
        consultaTenantAtual(query(collection(db, "dp_tipos_documentos"), orderBy("nome")))
      );

      const tiposDB = snap.docs.map(d => ({
  id: d.id,
  codigo: d.data().codigo || d.id,
  nome: d.data().nome,
  tipo: d.data().tipo, // ← CORREÇÃO
  obrigatorio: d.data().obrigatorio === true,
  temVencimento: d.data().temVencimento === true,
  periodicidadeMeses: d.data().periodicidadeMeses || null
}));

// 🔹 BASE POR TIPO (SUBSTITUI, NÃO SOMA)
if (!funcionario?.tipo) return;

const base = documentosBase[funcionario.tipo] || [];

// 🔹 TÉCNICOS
let extras = [];

if (funcionario?.cargo?.toLowerCase().includes("engenheiro")) {
  extras = documentosTecnicos.engenheiro;
}

if (funcionario?.cargo?.toLowerCase().includes("tecnico")) {
  extras = documentosTecnicos.tecnico;
}

// 🔹 CONVERTE
const tiposFixos = [...base, ...extras].map(doc => ({
  codigo: doc.nome.toUpperCase().replace(/\s+/g, "_"),
  nome: doc.nome,
  obrigatorio: doc.obrigatorio === true,
  temVencimento: doc.temVencimento === true,
  periodicidadeMeses: doc.periodicidadeMeses || null
}));

    let tiposFiltradosFinal = tiposFixos;

if (funcionario.tipo === "prestador") {
  tiposFiltradosFinal = tiposFixos.filter(t =>
    !["CPF", "CARTEIRA_DE_TRABALHO", "ATESTADO_DE_SAUDE_OCUPACIONAL_(ASO)"].includes(t.codigo)
  );
}


// 🔴 FILTRA DB PELO TIPO (IMPORTANTE)
const tiposDBFiltrado = tiposDB.filter(t => {
  if (funcionario?.tipo === "prestador") {
    return t.tipo === "prestador"; // precisa existir no banco
  }
  return t.tipo !== "prestador";
});

// 🔹 FINAL
const todos = [...tiposFiltradosFinal, ...tiposDBFiltrado];

const unicos = todos.filter((item, index, self) =>
  index === self.findIndex(t =>
    t.nome.trim().toLowerCase() === item.nome.trim().toLowerCase()
  )
);

setTiposDocumento(unicos);

    }
    carregarTipos();
  }, [reload, funcionario]);



  /* =========================
     DOCUMENTOS
  ========================= */
  useEffect(() => {
    async function carregarDocs() {
      const q = query(
        collection(db, "dp_documentos"),
        where("funcionarioId", "==", funcionarioId),
        orderBy("createdAt", "desc")
      );

      const snap = await getDocs(consultaTenantAtual(q));
      const lista = await Promise.all(
            snap.docs.map(async d => {
              const data = d.data();

             if (data.na || !data.storagePathAtual) {
              return { id: d.id, ...data, url: null };
            }

            const url = await getDownloadURL(ref(storage, data.storagePathAtual));
              return { id: d.id, ...data, url };
            })
          );
      setDocs(lista);
    }
    carregarDocs();
  }, [funcionarioId, reload]);

 /* =========================
   CHECKLIST
========================= */
useEffect(() => {
  const faltantes = tiposDocumento.filter(tipo => {
    const documento = docs.find(d =>
  d.tipoDocumentoNome?.trim().toLowerCase() === tipo.nome.trim().toLowerCase()
);

if (!documento) return true;

// N/A → não pendente
if (documento.na === true) return false;

// 🔴 SÓ NÃO É PENDENTE SE TIVER ARQUIVO
if (documento.storagePathAtual) return false;

// 👉 existe mas sem arquivo → continua pendente
return true;
  });

  setPendentes(faltantes);
}, [docs, tiposDocumento]);

                  /* =========================
                    SALVAR DOCUMENTO
                  ========================= */
                  async function salvarDocumento() {
                            if (!arquivo || !tipoSelecionado) return;

                            const tipo = tiposDocumento.find(t => t.codigo === tipoSelecionado);
                            if (!tipo) return;

                            // 🚫 BLOQUEIA SALVAR SEM DATA
                            if (tipo.temVencimento && !dataReferencia) {
                              alert("Informe a data do documento para calcular o vencimento.");
                              return;
                            }

                            setSalvando(true);

                            const docRef = doc(collection(db, "dp_documentos"));
                            const basePath = `dp/funcionarios/${funcionarioId}/${docRef.id}`;
                            const storagePathAtual = `${basePath}/v001.pdf`;

                            await uploadBytes(ref(storage, storagePathAtual), arquivo);

                           const dataRefDate = tipo.temVencimento
                                ? new Date(`${dataReferencia}T12:00:00`)
                                : null;

                              const dataVencimento = tipo.temVencimento
                                ? calcularDataVencimento(
                                    `${dataReferencia}T12:00:00`,
                                    tipo.periodicidadeMeses
                                  )
                                : null;


                            await setDoc(docRef, aplicarTenantAtual({
                                  funcionarioId,
                                  tipoDocumentoCodigo: tipo.codigo,
                                  tipoDocumentoNome: tipo.nome,
                                  nome: tipo.nome,
                                  revisaoAtual: 1,
                                  storagePathAtual,
                                  dataReferencia: dataRefDate,
                                  dataVencimento: dataVencimento,
                                  createdAt: serverTimestamp(),
                                  updatedAt: serverTimestamp()
                                }));


                            setDialogDoc(false);
                            setArquivo(null);
                            setTipoSelecionado("");
                            setDataReferencia("");
                            setSalvando(false);
                            setReload(r => r + 1);
                          }



      
            /* =========================
              CRIAR NOVO TIPO
            ========================= */
      async function salvarNovoTipo() {
  if (!novoNome) return;

  await addDoc(collection(db, "dp_tipos_documentos"), aplicarTenantAtual({
    codigo: novoNome.toUpperCase().replace(/\s+/g, "_"),
    nome: novoNome,
    tipo: funcionario?.tipo || "funcionario", // 🔴 ESSENCIAL
    obrigatorio: novoObrigatorio,
    temVencimento: novoTemVencimento,
    periodicidadeMeses: novoTemVencimento
      ? Number(novoPeriodicidade)
      : null,
    descricaoVencimento: novoTemVencimento
      ? novoDescricaoVencimento
      : null,
    ativo: true,
    criadoEm: serverTimestamp(),
    criadoPorUid: auth.currentUser.uid
  }));

  setNovoNome("");
  setNovoObrigatorio(false);
  setNovoTemVencimento(false);
  setNovoPeriodicidade("");
  setNovoDescricaoVencimento("");
  setDialogNovoTipo(false);
  setReload(r => r + 1);
}


  /* =========================
   UPLOAD / SUBSTITUIÇÃO
========================= */
async function uploadDocumentoDireto(tipo, file, docExistente) {
  if (!file) return;
   setUploadingCodigo(tipo.codigo);
  let docRef;
  let revisao = 1;

  if (docExistente) {
    // 🔁 SUBSTITUIÇÃO
    docRef = doc(db, "dp_documentos", docExistente.id);
    revisao = (docExistente.revisaoAtual || 1) + 1;
  } else {
    // ➕ NOVO
    docRef = doc(collection(db, "dp_documentos"));
  }

  const revFormatada = String(revisao).padStart(3, "0");
  const basePath = `dp/funcionarios/${funcionarioId}/${docRef.id}`;
  const storagePath = `${basePath}/v${revFormatada}.pdf`;

          await uploadBytes(ref(storage, storagePath), file);
          // 🔹 REGISTRO DE HISTÓRICO
        await addDoc(collection(db, "dp_documentos_historico"), aplicarTenantAtual({
              funcionarioId,
              documentoId: docRef.id,
              tipoDocumentoCodigo: tipo.codigo,
              tipoDocumentoNome: tipo.nome,
              revisao,
              storagePath,

              // ✅ NOME REAL DO PDF
              nomeArquivo: file.name,

              acao: docExistente ? "SUBSTITUICAO" : "INCLUSAO",
              motivoSubstituicao: docExistente ? motivoSubstituicao : null,
              usuarioUid: auth.currentUser.uid,
              usuarioEmail: auth.currentUser.email || "",
              usuarioNome: auth.currentUser.displayName || "",
              criadoEm: serverTimestamp()
            }));


         const dataRefDate = tipo.temVencimento
            ? new Date(`${dataReferencia}T12:00:00`)
            : null;

          const dataVencimento = tipo.temVencimento
            ? calcularDataVencimento(
                `${dataReferencia}T12:00:00`,
                tipo.periodicidadeMeses
              )
            : null;



                  await setDoc(
                  docRef,
                  aplicarTenantAtual({
                    funcionarioId,
                    tipoDocumentoCodigo: tipo.codigo,
                    tipoDocumentoNome: tipo.nome,
                    nome: tipo.nome,
                    revisaoAtual: revisao,
                    storagePathAtual: storagePath,

                    // ✅ CAMPOS QUE FALTAVAM
                    dataReferencia: dataRefDate,
                    dataVencimento: dataVencimento,

                    updatedAt: serverTimestamp(),
                    ...(docExistente ? {} : { createdAt: serverTimestamp() })
                  }),
                  { merge: true }
                );

  setUploadingCodigo(null);

  setReload(r => r + 1);
}

                /* =========================
                  ABRIR HISTÓRICO DO DOCUMENTO
                ========================= */
                async function abrirHistoricoDocumento(documento) {
                  if (!documento?.id) return;

                  const q = query(
                    collection(db, "dp_documentos_historico"),
                    where("documentoId", "==", documento.id),
                    orderBy("criadoEm", "desc")
                  );

                  const snap = await getDocs(consultaTenantAtual(q));

                  const lista = snap.docs.map(d => ({
                    id: d.id,
                    ...d.data()
                  }));

                  setHistoricoSelecionado(lista);
                  setDialogHistorico(true);
                }

  const tiposFiltrados = tiposDocumento.filter(tipo => {
  const documento = docs.find(d => d.tipoDocumentoCodigo === tipo.codigo);


if (filtroStatus === "todos") {
  return true;
}
  if (filtroStatus === "pendentes") {
    return !documento || documento.na !== true;
  }

  if (filtroStatus === "na") {
    return documento?.na === true;
  }

  // default (ativos)
  return !documento?.na;
});

  return (
    <Box>
     <Navbar />

<Box sx={{ mt: 2, px: 3 }}>
  <Button
    startIcon={<ArrowBackIcon />}
    onClick={() => history.goBack()}
  >
    Voltar
  </Button>
</Box>
      <Box p={3}>
        {funcionario && (
          <Card sx={{ mb: 3, p: 2 }}>
            

<Typography variant="h5" fontWeight={600}>
  {funcionario.nome}
</Typography>
            <Typography>{funcionario.cargo}</Typography>

            <Divider sx={{ my: 2 }} />

            {pendentes.length === 0 ? (
              <Typography color="success.main">
                ✅ Checklist de documentos completo
              </Typography>
            ) : (
              pendentes.map(p => (
                <Typography key={p.codigo} color="error.main">
                  ❌ {p.nome}
                </Typography>
              ))
            )}
          </Card>
        )}
           <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>

  <Button
    variant="contained"
    startIcon={<AddIcon />}
    onClick={() => setDialogNovoTipo(true)}
  >
    Novo Documento
  </Button>

  <FormControl sx={{ minWidth: 200 }}>
    <InputLabel>Status</InputLabel>
    <Select
      value={filtroStatus}
      label="Status"
      onChange={(e) => setFiltroStatus(e.target.value)}
    >
      <MenuItem value="ativos">Ativos</MenuItem>
      <MenuItem value="pendentes">Pendentes</MenuItem>
      <MenuItem value="na">N/A</MenuItem>
      <MenuItem value="todos">Todos</MenuItem>
    </Select>
  </FormControl>

</Box>


        <List>
                  {tiposFiltrados.map(tipo => {
                    const documento = docs.find(d =>
                        d.tipoDocumentoNome?.trim().toLowerCase() === tipo.nome.trim().toLowerCase()
                      );

                      const isNA = documento?.na === true;

                      const enviado =
  documento &&
  !documento.na &&
  documento.storagePathAtual
    ? documento
    : null;
                    return (
                      <ListItemButton
                        key={tipo.codigo}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          alignItems: "center"
                        }}
                      >

                      
                        {/* 🔗 ABRIR DOCUMENTO */}
                     <ListItemText
                        sx={{ 
                          flex: 1,
                          cursor: enviado ? "pointer" : "default"
                        }}
                          primary={`${tipo.nome}${tipo.obrigatorio ? " (obrigatório)" : ""}`}
                           secondary={
                              isNA ? (
                                "⚪ N/A"
                              ) : enviado ? (
                                <>
                                  <span>📄 Enviado</span>

                                          {tipo.temVencimento && (
                                            <span>
                                              {" • "}Exame:{" "}
                                              {enviado.dataReferencia?.toDate
                                                ? enviado.dataReferencia.toDate().toLocaleDateString("pt-BR")
                                                : "não informado"}
                                            </span>
                                          )}

                                          {tipo.temVencimento && (
                                            <span>
                                              {" • "}Vence:{" "}
                                              {enviado.dataVencimento?.toDate
                                                ? enviado.dataVencimento.toDate().toLocaleDateString("pt-BR")
                                                : "não calculado"}
                                            </span>
                                          )}
                                        </>
                                      ) : (
                                        "❌ Pendente"
                                      )
                                    }

                          
                          onClick={() => {
                              if (enviado && !enviado.na) {
                                window.open(enviado.url, "_blank");
                              }
                            }}
                
                     />

                        <Box sx={{ display: "flex", gap: 1, alignItems: "center", ml: "auto" }}>
  
  {!tipo.obrigatorio && (
    <FormControlLabel
      sx={{ mr: 1 }}
      control={
        <Checkbox
          checked={
          docs.find(d =>
            d.tipoDocumentoNome?.trim().toLowerCase() === tipo.nome.trim().toLowerCase()
          )?.na === true
        }
          onChange={async (e) => {
            const existente = docs.find(d =>
              d.tipoDocumentoNome?.trim().toLowerCase() === tipo.nome.trim().toLowerCase()
            );

            if (e.target.checked) {
              marcarComoNA(tipo);
            } else {
              if (existente) {
                await setDoc(
                  doc(db, "dp_documentos", existente.id),
                  { na: false },
                  { merge: true }
                );
                setReload(r => r + 1);
              }
            }
          }}
        />
      }
      label="N/A"
    />
  )}
                               {/* 📜 HISTÓRICO */}
                                {enviado && (
                                  <Button
                                      size="small"
                                      variant="outlined"
                                      onClick={() => abrirHistoricoDocumento(enviado)}
                                    >
                                      Histórico
                                    </Button>

                                )}

                           
                                
                                      {!isNA && (
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    disabled={uploadingCodigo === tipo.codigo}
                                    onClick={() => {
                                      setArquivo(null);
                                      setDataReferencia("");
                                      setMotivoSubstituicao("");

                                      setTipoUpload(tipo);
                                      setDocExistente(enviado || null);

                                      setDialogUpload(true);
                                    }}
                                  >
                                    {uploadingCodigo === tipo.codigo ? (
                                      <CircularProgress size={18} />
                                    ) : enviado ? (
                                      "Substituir"
                                    ) : (
                                      "Carregar documento"
                                    )}
                                  </Button>
                                )}


                              </Box>

                      </ListItemButton>
                    );
                  })}
                </List>
{/* =========================
    DIALOG – HISTÓRICO DO DOCUMENTO
========================= */}
<Dialog
  open={dialogHistorico}
  onClose={() => setDialogHistorico(false)}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle>Histórico do Documento</DialogTitle>

  <DialogContent dividers>
            {historicoSelecionado.length === 0 ? (
              <Typography>Nenhum histórico encontrado.</Typography>
            ) : (
              historicoSelecionado.map(h => (
                    <Box key={h.id} sx={{ mb: 2 }}>
                      <Typography variant="subtitle2">
                        📄 Versão: v{String(h.revisao).padStart(3, "0")}
                      </Typography>

                      {/* 🔗 LINK DO PDF DA VERSÃO */}
                      <Button
                            size="small"
                            variant="text"
                            sx={{ p: 0, minWidth: "auto", textTransform: "none" }}
                            onClick={() => abrirVersaoDocumento(h.storagePath)}
                          >
                            📄 {h.nomeArquivo || "Documento"}
                          </Button>


                      <Typography variant="body2">
                        📅 Data: {h.criadoEm?.toDate().toLocaleString("pt-BR")}
                      </Typography>

                      <Typography variant="body2">
                        👤 Responsável: {h.usuarioEmail || h.usuarioNome || "Usuário não identificado"}
                      </Typography>

                      <Typography variant="body2">
                        🔁 Ação: {h.acao === "SUBSTITUICAO" ? "Substituição" : "Inclusão"}
                      </Typography>

                      {h.acao === "SUBSTITUICAO" && h.motivoSubstituicao && (
                        <Typography variant="body2" sx={{ mt: 0.5 }}>
                          📝 Motivo da substituição: {h.motivoSubstituicao}
                        </Typography>
                      )}

                      <Divider sx={{ mt: 1 }} />
                    </Box>
                  ))


    )}


  </DialogContent>

  <DialogActions>
    <Button onClick={() => setDialogHistorico(false)}>
      Fechar
    </Button>
  </DialogActions>
</Dialog>
      {/* =========================
    DIALOG – UPLOAD / SUBSTITUIÇÃO
========================= */}
<Dialog
  open={dialogUpload}
  onClose={() => setDialogUpload(false)}
  fullWidth
>
  <DialogTitle>
    {docExistente ? "Substituir Documento" : "Carregar Documento"}
  </DialogTitle>

  <DialogContent>
    <Typography sx={{ mb: 2 }}>
      Documento: <strong>{tipoUpload?.nome}</strong>
    </Typography>

    {/* DATA DE REFERÊNCIA */}
    {tipoUpload?.temVencimento && (
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Data do documento (ex: data do exame)
        </Typography>

        <input
          type="date"
          style={{ width: "100%", padding: 10 }}
          value={dataReferencia}
          onChange={e => setDataReferencia(e.target.value)}
        />
      </Box>
    )}
        {/* MOTIVO DA SUBSTITUIÇÃO */}
{docExistente && (
  <Box sx={{ mb: 2 }}>
    <Typography variant="body2" sx={{ mb: 1 }}>
      Motivo da substituição
    </Typography>

    <input
      style={{ width: "100%", padding: 10 }}
      placeholder="Ex: Documento vencido, erro no envio anterior..."
      value={motivoSubstituicao}
      onChange={e => setMotivoSubstituicao(e.target.value)}
    />
  </Box>
)}

    {/* ARQUIVO */}
    <Button component="label" variant="outlined">
      Selecionar Arquivo
      <input
        hidden
        type="file"
        onChange={e => setArquivo(e.target.files[0])}
      />
    </Button>

    {/* NOME DO ARQUIVO SELECIONADO */}
          {arquivo && (
            <Typography
              variant="body2"
              sx={{ mt: 1, color: "text.secondary" }}
            >
              📄 {arquivo.name}
            </Typography>
          )}

  </DialogContent>

  <DialogActions>
                  <Button
                onClick={() => {
                  setDialogUpload(false);
                  setArquivo(null);
                  setDataReferencia("");
                  setMotivoSubstituicao("");
                }}
              >
                Cancelar
              </Button>


          <Button
              variant="contained"
              onClick={async () => {
                if (!arquivo) {
                  alert("Selecione um arquivo");
                  return;
                }

                if (tipoUpload?.temVencimento && !dataReferencia) {
                  alert("Informe a data do documento");
                  return;
                }
                if (docExistente && !motivoSubstituicao.trim()) {
                      alert("Informe o motivo da substituição");
                      return;
                    }


                setDialogUpload(false);

                uploadDocumentoDireto(
                  tipoUpload,
                  arquivo,
                  docExistente
                );

                setArquivo(null);
                setDataReferencia("");
                setMotivoSubstituicao("");
              }}
            >
              Salvar
            </Button>

        </DialogActions>
      </Dialog>


      </Box>                      

        
      {/* =========================
    NOVO TIPO DE DOCUMENTO
    ========================= */}
    <Dialog
      open={dialogNovoTipo}
    onClose={() => !salvandoCadastro && setDialogNovoTipo(false)}
      fullWidth
    >
      <DialogTitle>Novo Tipo de Documento</DialogTitle>

      <DialogContent>
        {/* NOME */}
        <input
          style={{ width: "100%", padding: 10, marginBottom: 12 }}
          placeholder="Nome do Documento"
          value={novoNome}
          onChange={e => setNovoNome(e.target.value)}
        />

        {/* OBRIGATÓRIO */}
        <FormControlLabel
          control={
            <Checkbox
              checked={novoObrigatorio}
              onChange={e => setNovoObrigatorio(e.target.checked)}
            />
          }
          label="Documento obrigatório"
        />

        {/* POSSUI VENCIMENTO */}
        <FormControlLabel
          control={
            <Checkbox
              checked={novoTemVencimento}
              onChange={e => setNovoTemVencimento(e.target.checked)}
            />
          }
          label="Documento possui vencimento"
        />

        {/* CAMPOS DE VENCIMENTO */}
        {novoTemVencimento && (
          <>
        <input
          type="number"
          style={{ width: "100%", padding: 10, marginTop: 12 }}
          placeholder="Periodicidade em meses (ex: 12)"
          value={novoPeriodicidade}
          onChange={e => setNovoPeriodicidade(e.target.value)}
        />

        <input
          style={{ width: "100%", padding: 10, marginTop: 12 }}
          placeholder="Descrição do vencimento (ex: ASO Periódico)"
          value={novoDescricaoVencimento}
          onChange={e => setNovoDescricaoVencimento(e.target.value)}
        />
      </>
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setDialogNovoTipo(false)} disabled={salvandoCadastro}>Cancelar</Button>
    <Button onClick={() => executarSalvamento(salvarNovoTipo)} variant="contained" disabled={salvandoCadastro}>
      {salvandoCadastro ? "Salvando..." : "Salvar"}
    </Button>
  </DialogActions>
</Dialog>

      
    </Box>
  );
}
